import * as actions from "Actions";
import * as api from "Api";

export const saveCalendarSettings = (plan, year, zone) => (
  dispatch,
  getState
) => {
  const {
    auth: { currentOrganization },
    calendarSettings: {
      data: { id }
    }
  } = getState();

  return dispatch(
    actions.saveCalendarSettings(
      api.saveCalendarSettings({
        annualCalendarId: id,
        planning: plan,
        organization: currentOrganization,
        year: year,
        zone: zone
      })
    )
  );
};

export const fetchCalendarSettings = (year, zone = null) => {
  return (dispatch, getState) => {
    const {
      auth: {
        currentOrganization: { id }
      }
    } = getState();
    return dispatch(
      actions.getCalendarSettings(api.getCalendarSettings(id, year, zone))
    );
  };
};

export const fetchCollaboratorAbsenceCalendarSettings = year => {
  return (dispatch, getState) => {
    const {
      auth: {
        currentOrganization,
        user: { uid, adminisId }
      },
      capacityPlaning: {
        collaborator: { collaborator }
      }
    } = getState();
    return dispatch(
      actions.getCalendarSettings(
        api.getCollaboratorAbsenceCalendarSettings(
          currentOrganization.id,
          collaborator ? collaborator.id : "",
          year,
          uid,
          adminisId
        )
      )
    );
  };
};

export const saveCollaboratorAbsenceCalendarSettings = (
  plan,
  year,
  month,
  attachments,
  isUpdating = "false"
) => (dispatch, getState) => {
  const {
    auth: { currentOrganization, user },
    calendarSettings: {
      data: { collaboratorId }
    }
  } = getState();

  return dispatch(
    actions.saveCalendarSettings(
      api.saveCollaboratorAbsenceCalendarSettings({
        user: user ? user.firstName + " " + user.lastName : "",
        planning: plan,
        files: attachments,
        organization: currentOrganization,
        collaboratorId: collaboratorId,
        year,
        month,
        isUpdating
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/calendar-settings.js